// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/blog/blogbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

#blog-container>#blog-main-cont{
    /* margin-bottom: 300px; */
    margin: auto;

}
#blog-container{
    width: 100%;
    height: auto;
    padding: 50px 0px 100px 0px;
    /* border: 2px solid red; */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
}
#blog-container>h1{
    margin-left: 10%;
}


#blog-container h1{
    font-size: 40px;
    color: #000000;
    font-weight: 600;
    text-align: left;
}

#blog-container span{
    font-size: 40px;
    color: #007bff;
    font-weight: 600;
}

#blog-main-cont{
    width: 80%;
    height: 592px;
    margin: 0px 0px;
    display: flex;
    align-items: center;
    background-color: #007bff;
    border-radius: 50px 50px 50px 50px;
}

#blog-main-cont img{
    width: 50%;
    height: 592px;
    border-radius: 50px 0 0 50px;
}

#blog-main-cont>div{
    width: 30%;
    height: auto;
    margin: 200px;
}

#blog-main-cont>div>button{
    width: auto;
    padding: 18px 33px;
    border: none; 
    outline: none;
    border-radius: 50px; 
    background-color: #ffffff;
    color: #007bff;
    font-weight: bold;
    /* cursor: pointer; */
    margin-bottom: 20px;
} 

#blog-main-cont h3{
    font-size: 40px;
    color: white;
    font-weight: 600;
    margin-bottom: 20px;
}

#blog-main-cont p{
    font-size: 18px;
    color: white;
    font-weight: 400;
    line-height: 1.5;
}

#blog-button-cont{
    width: 100%;
    height: auto;
    margin-top: 50px;
    display: grid;
    grid-template-columns: repeat(2,1fr);
    gap: 0px;
}

.blogButtons{
    width: auto;
    min-width: max-content;
    height: auto;
    padding: 8px;
    border-radius: 50px;
    background-color: #007bff;
    color: white;
    font-weight: bold;
    /* cursor: pointer; */
    border: 1px solid #ffffff;
    margin-bottom: 5px;
    margin-right: 5px;
}
@media (max-width: 1450px){
    #blog-main-cont>div{
        width: 40%;
        height: auto;
        margin: 100px;
    }
}
@media (max-width: 1680px){
    #blog-button-cont{
        grid-template-columns: repeat(3,1fr);
        gap: 0px;
    }
    #blog-main-cont>div{
        width: 40%;
        height: auto;
        margin: 100px;
    }
    
   }

/* Media Queries */

@media (max-width:1450px){
    #blog-button-cont{
        width: auto;
        min-width: max-content;
        height: auto;
        margin-top: 50px;
        display: grid;
        grid-template-columns: repeat(2,1fr);
        gap: 0px;
    }
}
@media (max-width: 1281px){
    #blog-main-cont {
        width: 90%;
        height: auto;
        flex-direction: row;
        border-radius: 50px 50px 50px 50px;
    }
    #blog-main-cont img {
        width: 50%;
        height: auto;
        border-radius: 50px 0 0 50px;
    }
    #blog-main-cont > div {
        width: 40%;
        /* margin-left: 5%; */
        /* margin: 0px; */
        margin: 0 0 0 5%;
    }
    #blog-main-cont h3 {
        font-size: 30px;
        margin-top: -10px;
    }
    #blog-main-cont p {
        font-size: 16px;
        margin-top: -10px;
    }
    #blog-button-cont{
        grid-template-columns: repeat(2,1fr);
        gap: 0px;
    }
    #blog-main-cont>div{
        padding:10px 0px;
    }
    #blog-main-cont>div>div{
        margin-top: -10px;
    }
}

@media (max-width: 500px){

    #blog-container{
        padding: 0px 0px 100px 0px;
    }

    #blog-container h1,
    #blog-container span {
        font-size: 24px;
        text-align: center;
    }
    #blog-main-cont {
        width: 100%;
        height: auto;
        flex-direction: column;
        border-radius: 20px 20px 20px 20px;
    }
    #blog-main-cont img {
        width: 100%;
        height: auto;
        border-radius: 20px 20px 0 0;
    }
    #blog-main-cont > div {
        width: 95%;
        margin: 10px auto;
        margin: 0px;
    }
    #blog-main-cont h3 {
        font-size: 24px;
    }
    #blog-main-cont p {
        font-size: 14px;
    }
    #blog-main-cont > div > button {
        padding: 10px 20px;
        font-size: 14px;
    }
    #blog-button-cont {
        grid-template-columns: 1fr;
    }
    .blogButtons {
        margin-bottom: 10px;
        margin-right: 0;
        width: 100%;
        /* cursor: pointer; */
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Blog.css"],"names":[],"mappings":";;AAEA;IACI,0BAA0B;IAC1B,YAAY;;AAEhB;AACA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,2BAA2B;IAC3B,yDAAkD;IAClD,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,oCAAoC;IACpC,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI;QACI,UAAU;QACV,YAAY;QACZ,aAAa;IACjB;AACJ;AACA;IACI;QACI,oCAAoC;QACpC,QAAQ;IACZ;IACA;QACI,UAAU;QACV,YAAY;QACZ,aAAa;IACjB;;GAED;;AAEH,kBAAkB;;AAElB;IACI;QACI,WAAW;QACX,sBAAsB;QACtB,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,oCAAoC;QACpC,QAAQ;IACZ;AACJ;AACA;IACI;QACI,UAAU;QACV,YAAY;QACZ,mBAAmB;QACnB,kCAAkC;IACtC;IACA;QACI,UAAU;QACV,YAAY;QACZ,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,qBAAqB;QACrB,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,oCAAoC;QACpC,QAAQ;IACZ;IACA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;QACZ,sBAAsB;QACtB,kCAAkC;IACtC;IACA;QACI,WAAW;QACX,YAAY;QACZ,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,iBAAiB;QACjB,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,mBAAmB;QACnB,eAAe;QACf,WAAW;QACX,qBAAqB;IACzB;AACJ","sourcesContent":["\r\n\r\n#blog-container>#blog-main-cont{\r\n    /* margin-bottom: 300px; */\r\n    margin: auto;\r\n\r\n}\r\n#blog-container{\r\n    width: 100%;\r\n    height: auto;\r\n    padding: 50px 0px 100px 0px;\r\n    /* border: 2px solid red; */\r\n    background-image: url(\"../assets/blog/blogbg.png\");\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n#blog-container>h1{\r\n    margin-left: 10%;\r\n}\r\n\r\n\r\n#blog-container h1{\r\n    font-size: 40px;\r\n    color: #000000;\r\n    font-weight: 600;\r\n    text-align: left;\r\n}\r\n\r\n#blog-container span{\r\n    font-size: 40px;\r\n    color: #007bff;\r\n    font-weight: 600;\r\n}\r\n\r\n#blog-main-cont{\r\n    width: 80%;\r\n    height: 592px;\r\n    margin: 0px 0px;\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: #007bff;\r\n    border-radius: 50px 50px 50px 50px;\r\n}\r\n\r\n#blog-main-cont img{\r\n    width: 50%;\r\n    height: 592px;\r\n    border-radius: 50px 0 0 50px;\r\n}\r\n\r\n#blog-main-cont>div{\r\n    width: 30%;\r\n    height: auto;\r\n    margin: 200px;\r\n}\r\n\r\n#blog-main-cont>div>button{\r\n    width: auto;\r\n    padding: 18px 33px;\r\n    border: none; \r\n    outline: none;\r\n    border-radius: 50px; \r\n    background-color: #ffffff;\r\n    color: #007bff;\r\n    font-weight: bold;\r\n    /* cursor: pointer; */\r\n    margin-bottom: 20px;\r\n} \r\n\r\n#blog-main-cont h3{\r\n    font-size: 40px;\r\n    color: white;\r\n    font-weight: 600;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n#blog-main-cont p{\r\n    font-size: 18px;\r\n    color: white;\r\n    font-weight: 400;\r\n    line-height: 1.5;\r\n}\r\n\r\n#blog-button-cont{\r\n    width: 100%;\r\n    height: auto;\r\n    margin-top: 50px;\r\n    display: grid;\r\n    grid-template-columns: repeat(2,1fr);\r\n    gap: 0px;\r\n}\r\n\r\n.blogButtons{\r\n    width: auto;\r\n    min-width: max-content;\r\n    height: auto;\r\n    padding: 8px;\r\n    border-radius: 50px;\r\n    background-color: #007bff;\r\n    color: white;\r\n    font-weight: bold;\r\n    /* cursor: pointer; */\r\n    border: 1px solid #ffffff;\r\n    margin-bottom: 5px;\r\n    margin-right: 5px;\r\n}\r\n@media (max-width: 1450px){\r\n    #blog-main-cont>div{\r\n        width: 40%;\r\n        height: auto;\r\n        margin: 100px;\r\n    }\r\n}\r\n@media (max-width: 1680px){\r\n    #blog-button-cont{\r\n        grid-template-columns: repeat(3,1fr);\r\n        gap: 0px;\r\n    }\r\n    #blog-main-cont>div{\r\n        width: 40%;\r\n        height: auto;\r\n        margin: 100px;\r\n    }\r\n    \r\n   }\r\n\r\n/* Media Queries */\r\n\r\n@media (max-width:1450px){\r\n    #blog-button-cont{\r\n        width: auto;\r\n        min-width: max-content;\r\n        height: auto;\r\n        margin-top: 50px;\r\n        display: grid;\r\n        grid-template-columns: repeat(2,1fr);\r\n        gap: 0px;\r\n    }\r\n}\r\n@media (max-width: 1281px){\r\n    #blog-main-cont {\r\n        width: 90%;\r\n        height: auto;\r\n        flex-direction: row;\r\n        border-radius: 50px 50px 50px 50px;\r\n    }\r\n    #blog-main-cont img {\r\n        width: 50%;\r\n        height: auto;\r\n        border-radius: 50px 0 0 50px;\r\n    }\r\n    #blog-main-cont > div {\r\n        width: 40%;\r\n        /* margin-left: 5%; */\r\n        /* margin: 0px; */\r\n        margin: 0 0 0 5%;\r\n    }\r\n    #blog-main-cont h3 {\r\n        font-size: 30px;\r\n        margin-top: -10px;\r\n    }\r\n    #blog-main-cont p {\r\n        font-size: 16px;\r\n        margin-top: -10px;\r\n    }\r\n    #blog-button-cont{\r\n        grid-template-columns: repeat(2,1fr);\r\n        gap: 0px;\r\n    }\r\n    #blog-main-cont>div{\r\n        padding:10px 0px;\r\n    }\r\n    #blog-main-cont>div>div{\r\n        margin-top: -10px;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px){\r\n\r\n    #blog-container{\r\n        padding: 0px 0px 100px 0px;\r\n    }\r\n\r\n    #blog-container h1,\r\n    #blog-container span {\r\n        font-size: 24px;\r\n        text-align: center;\r\n    }\r\n    #blog-main-cont {\r\n        width: 100%;\r\n        height: auto;\r\n        flex-direction: column;\r\n        border-radius: 20px 20px 20px 20px;\r\n    }\r\n    #blog-main-cont img {\r\n        width: 100%;\r\n        height: auto;\r\n        border-radius: 20px 20px 0 0;\r\n    }\r\n    #blog-main-cont > div {\r\n        width: 95%;\r\n        margin: 10px auto;\r\n        margin: 0px;\r\n    }\r\n    #blog-main-cont h3 {\r\n        font-size: 24px;\r\n    }\r\n    #blog-main-cont p {\r\n        font-size: 14px;\r\n    }\r\n    #blog-main-cont > div > button {\r\n        padding: 10px 20px;\r\n        font-size: 14px;\r\n    }\r\n    #blog-button-cont {\r\n        grid-template-columns: 1fr;\r\n    }\r\n    .blogButtons {\r\n        margin-bottom: 10px;\r\n        margin-right: 0;\r\n        width: 100%;\r\n        /* cursor: pointer; */\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
